var card_viewer_default = {
  "cardWrapper": "ryPnG",
  "cardContainer": "CzjwW",
  "cardContent": "osVkV",
  "pageSeparator": "c8WdS",
  "fluid": "_-6mRG",
  "print": "_3oA-1"
};
export {
  card_viewer_default as default
};
//# sourceMappingURL=card-viewer-scss.js.map
